import axios from 'axios';

export default class RegisterService {
  public processRegistration(account: any, token): Promise<any> {
    const headers = {
      response: token,
    };
    return new Promise<any>((resolve, reject) => {
      axios
        .post('api/public/register', account, {
          headers,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });

    // return api.post('api/register', account);
  }

  public processRegisterCreate(data: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('api/public/register-create', data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });

    // return api.post('api/register', account);
  }

  public processRegistrationBuy(account: any, token): Promise<any> {
    const headers = {
      response: token,
    };
    return new Promise<any>((resolve, reject) => {
      axios
        .post('api/public/register-buy', account, {
          headers,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });

    // return api.post('api/register', account);
  }
}
